module.exports = __webpack_public_path__ + "static/media/poster@2x.1a2f7566.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/poster@2x.png
// module id = 817
// module chunks = 0